import httpClient from '../http/http-client';

export default class SingleSignOnService {
  http;

  constructor() {
    this.http = httpClient
  }

  async singleSignOnSignUp(provider: string, token: string): Promise<any> {
    return this.http.post(`single-sign-on/sign-up/${provider}`, { token: token })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async singleSignOnLogIn(provider: string, token: string): Promise<any> {
    return this.http.post(`single-sign-on/log-in/${provider}`, { token: token })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async singleSignOnSignUpInvited(provider: string, token: string, passwordToken: string): Promise<any> {
    return this.http.post(`single-sign-on/sign-up-invited/${provider}`, { token: token, passwordToken: passwordToken  })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async completeSingleSignOnSignUp(values: any): Promise<any> {
    return this.http.post(`single-sign-on/complete-sign-up`, values)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async acceptTermsAndConditions(values: any): Promise<any> {
    return this.http.post(`single-sign-on/accept-terms-and-conditions`, values)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}